// Remembers the last column a user picked/created when making a task from a
// checklist item, keyed per board (columns differ between boards). Used to
// default the column dropdown on the next create so repeated creates land in
// the same column without re-selecting. localStorage-backed so it survives
// reloads; best-effort (private-mode / quota errors are swallowed).

const storageKey = (boardId: string): string =>
  `b4igo:checklist-default-column:${boardId}`

export const getLastChecklistColumn = (boardId?: string | null): string | null => {
  if (!boardId) return null
  try {
    return localStorage.getItem(storageKey(boardId))
  } catch {
    return null
  }
}

export const setLastChecklistColumn = (
  boardId?: string | null,
  columnId?: string | null
): void => {
  if (!boardId || !columnId) return
  try {
    localStorage.setItem(storageKey(boardId), columnId)
  } catch {
    /* ignore */
  }
}
